import { Component, OnInit, Input } from "@angular/core";
import { CategoriesService } from "src/app/shared/services/categories.service";
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";

@Component({
  selector: "product-filter",
  templateUrl: "./product-filter.component.html",
  styleUrls: ["./product-filter.component.scss"],
})
export class ProductFilterComponent implements OnInit {
  @Input("category") category;
  categories$;
  categories: any = [];
  reducedCategories: any = [];
  searchString: string;

  public selectControl = new FormControl();
  public selectItems = [];
  constructor(
    private categoryService: CategoriesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.categoryService.getAll().subscribe(
      (data) => {
        this.categories = data.data;
        this.selectItems = this.categories;
        this.reducedCategories = this.categories;
        this.reducedCategories = this.reducedCategories.slice(0, 15);
      },
      (err) => {
        console.log(err);
      }
    );

    this.categories = this.categoryService.getAll();

    this.selectControl.valueChanges.subscribe((subscriptionTypeId: number) => {
      const obj = this.selectItems.find(
        (item) => item.id === subscriptionTypeId
      );
      // this.showModuleArticles(obj.name, subscriptionTypeId);
      this.filterProduct(obj.name, subscriptionTypeId);
    });
  }

  filterProduct(categoryName: string, categoryId) {
    this.router.navigate(["/products"], {
      queryParams: { category: categoryName , qid : categoryId}
    });
  }
}
